<template>
  <div class="list-item">
    <router-link :to="link" class="wrap">
      <div class="left">
        <div class="t">{{item.title}}</div>
        <div class="delimit">─</div>
        <div class="category">{{item.category}}</div>
      </div>
      <div class="date">{{date}}</div>
    </router-link>
  </div>
</template>

<script>
import DateUtil from '../../util/date'
export default {
  props: ['item', 'link_prefix'],
  data: () => {
    return {
      message: ""
    }
  },
  computed: {
    link: function() {
      if(this.link_prefix) {
        return this.link_prefix + this.item.key
      } else {
        return '/diary/' + this.item.key
      }
    },
    date: function() {
      if(this.item.updated_at) {
        return DateUtil.format(new Date(this.item.updated_at))
      } else {
        return ""
      }
    }
  }
}
</script>
